import React from 'react';

import { useDispatch, useSelector } from "react-redux";

const PreloaderHomeSales = () => {

    const theme = useSelector((state) => state.initData.theme);
    
    return (
        <>
            {theme == 'dark' && (
                <svg width="775" height="152" viewBox="0 0 775 152" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_b_0_568)">
                    <rect width="253" height="152" rx="8" fill="#2C2C2E"/>
                    </g>
                    <g filter="url(#filter1_b_0_568)">
                    <rect x="261" width="253" height="152" rx="8" fill="#2C2C2E"/>
                    </g>
                    <g filter="url(#filter2_b_0_568)">
                    <rect x="522" width="253" height="152" rx="8" fill="#2C2C2E"/>
                    </g>
                    <defs>
                    <filter id="filter0_b_0_568" x="-40" y="-40" width="333" height="232" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_568"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_568" result="shape"/>
                    </filter>
                    <filter id="filter1_b_0_568" x="221" y="-40" width="333" height="232" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_568"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_568" result="shape"/>
                    </filter>
                    <filter id="filter2_b_0_568" x="482" y="-40" width="333" height="232" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_568"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_568" result="shape"/>
                    </filter>
                    </defs>
                </svg>                            
            ) || (
                <svg
                    width="775"
                    height="152"
                    viewBox="0 0 775 152"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g filter="url(#filter0_b_0_567)">
                        <rect width="253" height="152" rx="8" fill="#E9E9EB" />
                    </g>
                    <g filter="url(#filter1_b_0_567)">
                        <rect x="261" width="253" height="152" rx="8" fill="#E9E9EB" />
                    </g>
                    <g filter="url(#filter2_b_0_567)">
                        <rect x="522" width="253" height="152" rx="8" fill="#E9E9EB" />
                    </g>
                    <defs>
                        <filter
                            id="filter0_b_0_567"
                            x="-40"
                            y="-40"
                            width="333"
                            height="232"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_0_567"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_0_567"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter1_b_0_567"
                            x="221"
                            y="-40"
                            width="333"
                            height="232"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_0_567"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_0_567"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter2_b_0_567"
                            x="482"
                            y="-40"
                            width="333"
                            height="232"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_0_567"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_0_567"
                                result="shape"
                            />
                        </filter>
                    </defs>
                </svg>
            )}
        </>
    );
};

export default PreloaderHomeSales;
